import type { EditorEntry } from "../api/systemApi";

export type EditorIconProps = {
  editorId: EditorEntry["id"];
  size?: number;
};

// Cursor's mark — three rhombuses forming a 3D cube. Uses currentColor so it
// adapts to theme (renders as fg-0 on dark, dark on light).
const CursorIcon = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M11.925 24l10.425-6-10.425-6L1.5 18l10.425 6z" opacity="0.85" />
    <path d="M22.35 18V6L11.925 0v12l10.425 6z" opacity="0.55" />
    <path d="M11.925 0L1.5 6v12l10.425-6V0z" />
  </svg>
);

// VS Code's classic blue folded-paper mark — fixed brand color, works on
// any background.
const VSCodeIcon = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="#0098FF"
    aria-hidden="true"
  >
    <path d="M23.15 2.587 18.21.21a1.494 1.494 0 0 0-1.705.29l-9.46 8.63-4.12-3.128a.999.999 0 0 0-1.276.057L.327 7.261A1 1 0 0 0 .326 8.74L3.899 12 .326 15.26a1 1 0 0 0 .001 1.479L1.65 17.94a.999.999 0 0 0 1.276.057l4.12-3.128 9.46 8.63a1.492 1.492 0 0 0 1.704.29l4.942-2.377A1.5 1.5 0 0 0 24 20.06V3.939a1.5 1.5 0 0 0-.85-1.352zm-5.146 14.861L10.826 12l7.178-5.448v10.896Z" />
  </svg>
);

export const EditorIcon = ({ editorId, size = 14 }: EditorIconProps) => {
  if (editorId === "cursor") return <CursorIcon size={size} />;
  if (editorId === "vscode") return <VSCodeIcon size={size} />;
  return null;
};
